var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "controls-disabled": _vm.controlsDisabled,
            "button-bar-items": _vm.buttonBarItems,
            "context-menu-items": _vm.contextMenuItems,
            "search-enabled": _vm.searchEnabled,
            "url-query-params": "",
          },
          on: {
            processPayment: function ($event) {
              return _vm.processPayment($event)
            },
            sendReminder: function ($event) {
              return _vm.sendReminder($event)
            },
            printSale: function ($event) {
              return _vm.printSale($event)
            },
            downloadSale: function ($event) {
              return _vm.downloadSale($event)
            },
            sendSale: function ($event) {
              return _vm.sendSale($event)
            },
            sendPortal: function ($event) {
              return _vm.sendPortal($event)
            },
            downloadUbl: function ($event) {
              return _vm.downloadUbl($event)
            },
            createPublicLink: function ($event) {
              return _vm.createPublicLink($event)
            },
            convertToCreditNote: function ($event) {
              return _vm.convertToCreditNote()
            },
            state: function ($event) {
              _vm.browseState = $event
            },
            saveAs: function ($event) {
              return _vm.saveAs($event)
            },
            "context-menu-item": function ($event) {
              _vm.selectedContextMenuItem = $event
            },
            "col-click-result": _vm.onColClick,
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm.hasUblModule
            ? _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("createUblArchive"),
                      expression: "$ct('createUblArchive')",
                    },
                  ],
                  attrs: { slot: "extra-buttons" },
                  on: {
                    click: function ($event) {
                      return _vm.createUblArchive()
                    },
                  },
                  slot: "extra-buttons",
                },
                [_c("w-fa", { attrs: { icon: "file-archive" } })],
                1
              )
            : _vm._e(),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.quickBankEditSale != null },
          on: {
            input: function ($event) {
              _vm.quickBankEditSale = null
            },
          },
        },
        [
          _vm.quickBankEditSale
            ? _c("app-bank-edit", {
                attrs: { sale: _vm.quickBankEditSale },
                on: {
                  cancel: function ($event) {
                    _vm.quickBankEditSale = null
                  },
                  update: function ($event) {
                    _vm.updateView(),
                      (_vm.quickBankEditSale = null),
                      _vm.cancelSelection()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.saleReminder,
            callback: function ($$v) {
              _vm.saleReminder = $$v
            },
            expression: "saleReminder",
          },
        },
        [
          _c("app-sale-reminder", {
            attrs: { "contact-id": _vm.selectedContactId },
            on: {
              close: function ($event) {
                return _vm.closeSaleRemidner()
              },
              cancel: function ($event) {
                _vm.saleReminder = false
              },
            },
          }),
        ],
        1
      ),
      _vm.sendModal
        ? _c("app-send-sale", {
            attrs: { sale: _vm.toSendSale },
            on: {
              close: function ($event) {
                _vm.sendModal = false
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.publicLinkModal,
            callback: function ($$v) {
              _vm.publicLinkModal = $$v
            },
            expression: "publicLinkModal",
          },
        },
        [
          _c("app-public-link", {
            attrs: { link: _vm.publicLink },
            on: {
              cancel: function ($event) {
                return _vm.closePublicLink()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.sendPortalModal,
            callback: function ($$v) {
              _vm.sendPortalModal = $$v
            },
            expression: "sendPortalModal",
          },
        },
        [
          _vm.sendPortalModal && _vm.toSendSale
            ? _c("app-send-portal", {
                attrs: {
                  sale: _vm.toSendSale,
                  contact: _vm.toSendSale.Contact,
                },
                on: {
                  cancel: function ($event) {
                    _vm.sendPortalModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createUblArchiveModal,
            callback: function ($$v) {
              _vm.createUblArchiveModal = $$v
            },
            expression: "createUblArchiveModal",
          },
        },
        [
          _vm.createUblArchiveModal
            ? _c("app-create-ubl-archive-modal", {
                on: {
                  close: function ($event) {
                    _vm.createUblArchiveModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/purchase-documents",
            "escape-close": "",
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "parent-should-refresh": function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.saveAsModal,
            callback: function ($$v) {
              _vm.saveAsModal = $$v
            },
            expression: "saveAsModal",
          },
        },
        [
          _vm.saveAsModal
            ? _c("app-save-as-modal", {
                attrs: { sales: _vm.selectedItems },
                on: {
                  close: function ($event) {
                    _vm.saveAsModal = false
                  },
                  refresh: function ($event) {
                    return _vm.updateView()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.peppolModalOpen } },
        [
          _vm.peppolModalOpen
            ? _c("app-send-via-peppol-modal", {
                attrs: { sale: _vm.toSendSale },
                on: {
                  close: function ($event) {
                    _vm.peppolModalOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.editDeliveryDateModalSale
        ? _c("app-sale-edit-delivery-date-modal", {
            attrs: { sale: _vm.editDeliveryDateModalSale },
            on: {
              close: function ($event) {
                _vm.editDeliveryDateModalSale = null
              },
            },
          })
        : _vm._e(),
      _vm.convertToCreditNoteModal
        ? _c("app-convert-to-credit-note-modal", {
            attrs: { sales: _vm.selectedItems },
            on: {
              close: function ($event) {
                _vm.convertToCreditNoteModal = false
              },
              confirm: function ($event) {
                return _vm.doConvertToCreditNote($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }